var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }, [_c("w-spacer")], 1),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _vm.mailSettings
                    ? _c("app-mail-settings", {
                        attrs: { "mail-settings": _vm.mailSettings },
                        on: {
                          "mail-settings": function ($event) {
                            return _vm.onSettingsSaved($event)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }